import { useId } from "react";

import { Spinner } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import InfoTooltip from "../../../InfoTooltip/InfoTooltip";

import style from "./CheckoutSummaryRow.module.css";

export const CheckoutSummaryRow = ({
  name,
  subTitle,
  hasDiscount,
  price,
  discountedPrice,
  nameTooltipText,
  priceTooltipText,
  currencySymbol,
  isLoading,
  isPriceHighlighted,
  isNameHighlighted,
}: {
  name: string;
  subTitle?: string;
  hasDiscount?: boolean;
  price?: string;
  discountedPrice?: string;
  nameTooltipText?: string;
  priceTooltipText?: string;
  currencySymbol?: string;
  isLoading?: boolean;
  isPriceHighlighted?: boolean;
  isNameHighlighted?: boolean;
}) => {
  const labelID = useId();
  return (
    <div
      className={classNames(style.checkoutRow, hasDiscount && style.discount)}
      aria-labelledby={labelID}
    >
      <div>
        <label className={classNames(isNameHighlighted && style.highlighted)} id={labelID}>
          {name}
          {nameTooltipText && (
            <>
              {" "}
              <InfoTooltip content={nameTooltipText} />
            </>
          )}
        </label>
        {subTitle && (
          <div className={classNames(style.subTitle, isLoading && style.hidden)}>{subTitle}</div>
        )}
      </div>
      {isLoading && (
        <div>
          <Spinner size={20} />
        </div>
      )}
      {!isLoading && !discountedPrice && (
        <div className={classNames(isPriceHighlighted && style.highlighted)}>
          {hasDiscount && <span>-</span>}
          {currencySymbol}
          {price} {priceTooltipText && <InfoTooltip content={priceTooltipText} />}
        </div>
      )}
      {!isLoading && discountedPrice && (
        <div
          className={classNames(
            style.discountedPriceContainer,
            isPriceHighlighted && style.highlighted
          )}
        >
          <span className={style.originalPrice}>
            {currencySymbol}
            {price}
          </span>
          <span>
            {currencySymbol}
            {discountedPrice}
          </span>
          {priceTooltipText && <InfoTooltip content={priceTooltipText} />}
        </div>
      )}
    </div>
  );
};
